import React, { useEffect, useState } from "react";
import { DataGrid, GridColDef, GridToolbar } from "@mui/x-data-grid";
import axios from "axios";
import HOST_URL from "../../../utils/Url";
import Card from "@mui/material/Card";
import { Box, Button, Divider, Grid, Stack, TextField, Typography } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import Switch from "@mui/material/Switch";
import { useNavigate, useLocation } from "react-router-dom";
import Chip from "@mui/material/Chip";
import { useTranslation } from "react-i18next";
import Paper from "@mui/material/Paper";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import { toast } from "react-toastify";
import ToastApp from "../../../ToastApp";
import DeleteIcon from "@mui/icons-material/Delete";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import CircularProgress from "@mui/material/CircularProgress";
import { useFormik } from "formik";
import * as Yup from "yup";
import dayjs from "dayjs";
import { secureGetItem } from "../../../utils/encryption";

interface MenuPermission {
  isAdd: boolean;
  isEdit: boolean;
  isPrint: boolean;
  isDel: boolean;
}

export default function DocType() {
  const [Docs, setDocs] = useState([]);
  const [columns, setColumns] = useState<any>([]);
  const [isLoading, setIsLoading] = useState(true);
  const location = useLocation();
  const [permissionLoaded, setPermissionLoaded] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const [permissionData, setPermissionData] = useState<MenuPermission>({
    isAdd: false,
    isEdit: false,
    isPrint: false,
    isDel: false,
  });

  let navigate = useNavigate();
  const { t } = useTranslation();
  const [toaster, setToaster] = useState(false);
  const requiredFields = ['DocType'];
  const [isEdit, setIsEdit] = useState(false);


useEffect(() => {
  const data = secureGetItem("userdata");   // ✅ decrypt + parse

  if (data && data.length > 0) {
    const userPermissionData = data[0]?.userPermission;
    const menudata = userPermissionData?.[0]?.parentMenu || [];

    for (let i = 0; i < menudata.length; i++) {
      const childMenudata = menudata[i]?.childMenu || [];
      const pathrow = childMenudata.find(
        (x: any) => x.path === location.pathname
      );

      if (pathrow) {
        setPermissionData({
          isAdd: pathrow.isAdd,
          isEdit: pathrow.isEdit,
          isPrint: pathrow.isPrint,
          isDel: pathrow.isDel,
        });
        break;
      }
    }
  }
setPermissionLoaded (true);
  // fetchZonesData();
}, [location.pathname]);

// Agar add permission ho to form show karo
useEffect(() => {
  if (permissionLoaded && permissionData?.isAdd) {
    setShowForm(true);
    setIsEdit(false);
    formik.resetForm();
  } else {
    setShowForm(false);
  }
}, [permissionData?.isAdd, permissionLoaded]);

  const routeChangeAdd = () => {
    // Add button ab nahi hai, isliye ye function use nahi hoga
  };



 const routeChangeEdit = (row: any) => {
  if (!permissionData?.isEdit) {
    toast.error("You don't have edit permission");
    return;
  }

  setIsEdit(true);
  setShowForm(true);   // ✅ Edit click pe form dikhe
    formik.setFieldValue("doc_Name", row.doc_Name)
    formik.setFieldValue("docID", row.docID);
    formik.setFieldValue("doc_shortname", row.doc_shortname);
    formik.setFieldValue("session_year", row.session_year);
    formik.setFieldValue("entry_Date", row.entry_Date);
    formik.setFieldValue("inst_ID", row.inst_ID);
    formik.setFieldValue("parentDocId", row.parentDocId);
    formik.setFieldValue("parentLevel", row.parentLevel);
    formik.setFieldValue("userId", row.userId);
    formik.setFieldValue("parentDoc_Name", row.parentDoc_Name);
    formik.setFieldValue("srn", row.srn);
    formik.setFieldValue("serialNo", row.serialNo);
    formik.setFieldValue("id", row.id);
  };

  let delete_id = "";

  const accept = () => {
    const collectData = {
      docID: delete_id,
    };
    console.log("collectData " + JSON.stringify(collectData));
    axios
      .post(HOST_URL.HOST_URL2 + `OtherDocType/DeleteOtherDocType`,
      collectData)
      .then((response) => {
        if (response.data.isSuccess) {
          toast.success(response.data.mesg);
        } else {
          toast.error(response.data.mesg);
        }
        fetchDocData();
      });
  };

  const reject = () => {
    toast.warn("Rejected: You have rejected", { autoClose: 3000 });
  };
     useEffect(() => {
        if(permissionLoaded){
      fetchDocData();
        }
    }, [permissionLoaded]); 

  const handledeleteClick = (del_id: any) => {
    // console.log(del_id + " del_id ");
    delete_id = del_id;
    confirmDialog({
      message: "Do you want to delete this record ?",
      header: "Delete Confirmation",
      icon: "pi pi-info-circle",
      acceptClassName: "p=-button-danger",
      accept,
      reject,
    });
  };

  const fetchDocData = async () => {
    try {
      const collectData = {
        docID: -1,
        parentDocId: 0,
        userId: "",
      };
      console.log("collectData", collectData);
      const response = await axios.post(
        HOST_URL.HOST_URL2 + `OtherDocType/GetOtherDocType`,
        collectData
      );
      console.log("result", response.data.data);
      const data = response.data.data;
      const DocsWithIds = data.map((doc: any, index: any) => ({
        ...doc,
        serialNo: index + 1,
        id: doc.docID,
      }));

      setDocs(DocsWithIds);
      setIsLoading(false);

      if (data.length > 0) {
         const actionColumn: GridColDef[] =
          permissionData?.isEdit || permissionData?.isDel
            ? [
                {
                  field: "actions",
                  headerClassName: "MuiDataGrid-colCell",
                  headerName: t("text.Action"),
                  width: 150,
                  renderCell: (params) => (
                    <Stack spacing={1} direction="row" sx={{ alignItems: "center", marginTop: "5px" }}>
                      {permissionData?.isEdit && (
                        <EditIcon
                          style={{ fontSize: "20px", color: "blue", cursor: "pointer" }}
                          onClick={() => routeChangeEdit(params.row)}
                        />
                      )}
        
                      {permissionData?.isDel && (
                        <DeleteIcon
                          style={{ fontSize: "20px", color: "red", cursor: "pointer" }}
                          onClick={() => handledeleteClick(params.row.id)}
                        />
                      )}
                    </Stack>
                  ),
                },
              ]
            : [];
        const columns: GridColDef[] = [
          ...actionColumn,
         

          {
            field: "serialNo",
            headerName: t("text.SrNo"),
            flex: 1,
            headerClassName: "MuiDataGrid-colCell",
            minWidth: 60
          },

          // {
          //   field: "parentDoc_Name",
          //   headerName: t("text.DocType"),
          //   flex: 1,
          //   headerClassName: "MuiDataGrid-colCell",
          // },
          {
            field: "doc_Name",
            headerName: t("text.DocType"),
            flex: 1,
            headerClassName: "MuiDataGrid-colCell",
            minWidth: 150
          },

          {
            field: "doc_shortname",
            headerName: t("text.ShortName"),
            flex: 1,
            headerClassName: "MuiDataGrid-colCell",
            minWidth: 120
          },
         
        ];
        setColumns(columns as any);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      // setLoading(false);
    }
  };

  const adjustedColumns = columns.map((column: any) => ({
    ...column,
  }));


  const validationSchema = Yup.object({
    doc_Name: Yup.string().test(
      'required',

      function (value: any) {
        return value && value.trim() !== '';
      }
    ),
  });


  const formik = useFormik({
    initialValues: {
      docID: -1,
      doc_Name: "",
      doc_shortname: "",
      session_year: "",
      entry_Date: dayjs(new Date()).format("YYYY-MM-DD"),
      inst_ID: 0,
      parentDocId: 0,
      parentLevel: 0,
      userId: "",
      parentDoc_Name: "",
      srn: 0
    },
    validationSchema: validationSchema,
    onSubmit: async (values) => {

      const response = await axios.post(
        HOST_URL.HOST_URL2 + `OtherDocType/AddUpdateOtherDocType`,
        values
      );
      try {
        setToaster(false);
        toast.success(response.data.mesg);
        setIsEdit(false);
        // Save ke baad bhi form close nahi hoga agar add permission hai
        if (!permissionData?.isAdd) {
          setShowForm(false);
        }
        formik.resetForm();
        fetchDocData();
        // navigate('/DocManagement/DocType');
      } catch (error) {
        setToaster(true);
        toast.error(response.data.mesg);
      }
    },
  });

  const handleReset = () => {
    formik.resetForm();
    setIsEdit(false);
    // Reset pe form close karo agar add permission nahi hai
    if (!permissionData?.isAdd) {
      setShowForm(false);
    }
  };


  return (
    <>
      <Card
        style={{
          width: "100%",
          // height: "100%",
          backgroundColor: "#E9FDEE",
          border: ".5px solid #FF7722 ",
          // marginTop: "3vh",
        }}
      >
        <Paper
          sx={{
            width: "100%",
            overflow: "hidden",
            "& .MuiDataGrid-colCell": {
              backgroundColor: `var(--grid-headerBackground)`,
              color: `var(--grid-headerColor)`,
              fontSize: 17,
              fontWeight: 900,
            },
          }}
          style={{ padding: "10px" }}
        >
          <ConfirmDialog />

          <Typography
            gutterBottom
            variant="h5"
            component="div"
            sx={{ padding: "20px" }}
            align="left"
          >
            {t("text.DocType")}
          </Typography>
          <Divider />

          <Box height={10} />

    
{showForm && (
          <form onSubmit={formik.handleSubmit}>
            {toaster === false ? "" : <ToastApp />}
            <Grid item xs={12} container spacing={2}>

              <Grid xs={12} md={6} item>
                <TextField
                  label={
                    <span>
                      {t("text.EnterDocName")} {requiredFields.includes('DocType') && (
                        <span style={{ color: formik.values.doc_Name ? 'green' : 'red' }}>*</span>
                      )}
                    </span>
                  }
                  value={formik.values.doc_Name}
                  placeholder={t("text.EnterDocName")}
                  size="small"
                  fullWidth
                  name="doc_Name"
                  id="doc_Name"
                  style={{ backgroundColor: "white" }}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
                {formik.touched.doc_Name && formik.errors.doc_Name ? (
                  <div style={{ color: "red", margin: "5px" }}>{formik.errors.doc_Name}</div>
                ) : null}
              </Grid>

              <Grid xs={12} md={6} item>
                <TextField
                  label={t("text.EnterShortName")}
                  value={formik.values.doc_shortname}
                  placeholder={t("text.EnterShortName")}
                  size="small"
                  fullWidth
                  name="doc_shortname"
                  id="doc_shortname"
                  style={{ backgroundColor: "white" }}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
              </Grid>

              <Grid item xs={12} spacing={2} style={{ display: 'flex', justifyContent: 'center' }}>
                <Grid xs={6} style={{ margin: '6px' }}>
                  <Button
                    type="submit"
                    fullWidth
                    style={{
                      backgroundColor: `var(--header-background)`,
                      color: "white",
                      marginTop: "10px",
                    }}

                  >
                    {isEdit ? t("text.update") : t("text.save")}
                  </Button>
                </Grid>

                <Grid xs={6} style={{ margin: '6px' }}>
                  <Button
                    type="reset"
                    fullWidth
                    style={{
                      backgroundColor: "#F43F5E",
                      color: "white",
                      marginTop: "10px",
                    }}
                    onClick={handleReset}
                  >
                    {t("text.reset")}
                  </Button>
                </Grid>

              </Grid>
            </Grid>
            {/* </Card> */}
          </form>
)}

          {isLoading ? (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <CircularProgress />
            </div>
          ) : (
            <Box>
              <br />
              <div style={{ width: "100%", backgroundColor: `var(--grid-background)` }}>
                <DataGrid
                  rows={Docs}
                  columns={adjustedColumns}
                  autoHeight
                  slots={{
                    toolbar: GridToolbar,
                  }}
                  rowSpacingType="border"
                  pagination={true}
                  pageSizeOptions={[5, 10, 25, 50, 100].map((size) => ({
                    value: size,
                    label: `${size}`,
                  }))}
                  initialState={{
                    pagination: { paginationModel: { pageSize: 5 } },
                  }}
                  slotProps={{
                    toolbar: {
                      showQuickFilter: true,
                    },
                  }}
                />
              </div>
            </Box>
          )}
        </Paper>
      </Card>
      <ToastApp />
    </>
  );
}
